import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'
import { useBadgeStyles } from './useBadgeStyles'

const ICON_SIZES = {
  xs: 10,
  sm: 12,
  md: 14
}

function SydBadge ({ children, variant, size, opacity, icon, className, style }) {
  const classes = useBadgeStyles({ variant, size, opacity })
  const iconElement = useMemo(() => {
    return icon ? <Icon name={icon} customSize={ICON_SIZES[size]} /> : null
  }, [icon, size])

  return (
    <span className={clsx(classes.badge, className)} style={style}>
      {iconElement}
      {children}
    </span>
  )
}

SydBadge.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'success', 'warning', 'danger', 'info', 'neutral', 'ai']),
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  opacity: PropTypes.number,
  icon: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

SydBadge.defaultProps = {
  variant: 'neutral',
  size: 'sm',
  opacity: 0.15
}

export default SydBadge
